var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.isLoggedIn
        ? "wrapper d-flex align-items-stretch route-" +
          _vm.$router.currentRoute.name
        : ""
    },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.isLoggedIn ? "side-nav-active" : "",
          attrs: { id: "content" }
        },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dataLoading,
              expression: "dataLoading"
            }
          ],
          attrs: { id: "global-spinner" }
        },
        [_c("b-spinner", { attrs: { label: "Loading" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }